var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.bookingReady
    ? _c("div", { staticClass: "booking-check-out" }, [
        _c(
          "div",
          { staticClass: "booking-checkout-form-wrapper" },
          [
            _vm.isBookingEditMode
              ? _c("modify-edit-banner", {
                  attrs: {
                    "is-room-list": false,
                    "is-guest-or-payment-info": true,
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _c("checkout-form", {
              key: JSON.stringify(_vm.user),
              ref: "checkoutForm",
              attrs: { "redirect-url": _vm.checkoutRedirectUrl },
              on: {
                loading: function ($event) {
                  _vm.isLoading = $event
                },
                error: function ($event) {
                  return _vm.onExternalError($event)
                },
                "external-error": function ($event) {
                  return _vm.onExternalError($event)
                },
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "default",
                    fn: function (ref) {
                      var serverErrorMsg = ref.serverErrorMsg
                      return _c(
                        "form",
                        {
                          staticClass: "mohg-form booking-check-out-form",
                          attrs: { action: _vm.checkoutFormApi },
                        },
                        [
                          _c("fieldset", [
                            _c("legend", [
                              _vm._v(
                                _vm._s(_vm.tc("booking.fanClubFieldsTitle"))
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "flex-grid-2-col gutter-md" },
                              [
                                _c("div", { staticClass: "input" }, [
                                  _c("input", {
                                    staticClass: "req",
                                    attrs: {
                                      id: "agentTitle",
                                      type: "text",
                                      name: "agentTitle",
                                      maxlength: "255",
                                      "data-val": "true",
                                      "data-val-required":
                                        _vm.getValidationForField(
                                          "required",
                                          "title"
                                        ),
                                      "data-field-type": "SingleLineText",
                                      "data-default-value":
                                        _vm.agent &&
                                        _vm.agent.agentName &&
                                        _vm.agent.agentName.salutation,
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    {
                                      staticClass: "req floating",
                                      attrs: { for: "agentTitle" },
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(_vm.tc("formFields.title")) +
                                          "\n              "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("span", {
                                    staticClass: "field-validation-valid",
                                    attrs: {
                                      "data-valmsg-for": "agentTitle",
                                      "data-valmsg-replace": "true",
                                    },
                                  }),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "input" }, [
                                  _c("input", {
                                    staticClass: "req",
                                    attrs: {
                                      id: "agentFirstname",
                                      type: "text",
                                      name: "agentFirstname",
                                      maxlength: "255",
                                      "data-val": "true",
                                      "data-rule-minlength": "1",
                                      "data-rule-maxlength": "50",
                                      "data-msg-minlength":
                                        _vm.getValidationForField(
                                          "minChars",
                                          "1"
                                        ),
                                      "data-msg-maxlength":
                                        _vm.getValidationForField(
                                          "maxChars",
                                          "50"
                                        ),
                                      "data-val-no-special-chars": _vm.tc(
                                        "validations.noSpecialChars"
                                      ),
                                      "data-val-required":
                                        _vm.getValidationForField(
                                          "required",
                                          "firstName"
                                        ),
                                      "data-field-type": "SingleLineText",
                                      "data-default-value":
                                        _vm.agent &&
                                        _vm.agent.agentName &&
                                        _vm.agent.agentName.firstName,
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    {
                                      staticClass: "req floating",
                                      attrs: { for: "agentFirstname" },
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.tc("formFields.firstName")
                                          ) +
                                          "\n              "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("span", {
                                    staticClass: "field-validation-valid",
                                    attrs: {
                                      "data-valmsg-for": "agentFirstname",
                                      "data-valmsg-replace": "true",
                                    },
                                  }),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "input" }, [
                                  _c("input", {
                                    staticClass: "req",
                                    attrs: {
                                      id: "agentLastname",
                                      type: "text",
                                      name: "agentLastname",
                                      maxlength: "255",
                                      "data-val": "true",
                                      "data-rule-minlength": "1",
                                      "data-rule-maxlength": "65",
                                      "data-msg-minlength":
                                        _vm.getValidationForField(
                                          "minChars",
                                          "1"
                                        ),
                                      "data-msg-maxlength":
                                        _vm.getValidationForField(
                                          "maxChars",
                                          "65"
                                        ),
                                      "data-val-no-special-chars": _vm.tc(
                                        "validations.noSpecialChars"
                                      ),
                                      "data-val-required":
                                        _vm.getValidationForField(
                                          "required",
                                          "lastName"
                                        ),
                                      "data-field-type": "SingleLineText",
                                      "data-default-value":
                                        _vm.agent &&
                                        _vm.agent.agentName &&
                                        _vm.agent.agentName.lastName,
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    {
                                      staticClass: "req floating",
                                      attrs: { for: "agentLastname" },
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.tc("formFields.lastName")
                                          ) +
                                          "\n              "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("span", {
                                    staticClass: "field-validation-valid",
                                    attrs: {
                                      "data-valmsg-for": "agentLastname",
                                      "data-valmsg-replace": "true",
                                    },
                                  }),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "input" }, [
                                  _c("input", {
                                    staticClass: "req",
                                    attrs: {
                                      id: "agencyName",
                                      type: "text",
                                      name: "agencyName",
                                      maxlength: "255",
                                      "data-val": "true",
                                      "data-rule-minlength": "1",
                                      "data-rule-maxlength": "255",
                                      "data-msg-minlength":
                                        _vm.getValidationForField(
                                          "minChars",
                                          "1"
                                        ),
                                      "data-msg-maxlength":
                                        _vm.getValidationForField(
                                          "maxChars",
                                          "255"
                                        ),
                                      "data-val-required":
                                        _vm.getValidationForField(
                                          "required",
                                          "agencyName"
                                        ),
                                      "data-field-type": "SingleLineText",
                                      "data-default-value":
                                        _vm.agent && _vm.agent.agencyAgencyName,
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    {
                                      staticClass: "req floating",
                                      attrs: { for: "agencyName" },
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.tc("formFields.agencyName")
                                          ) +
                                          "\n              "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("span", {
                                    staticClass: "field-validation-valid",
                                    attrs: {
                                      "data-valmsg-for": "agencyName",
                                      "data-valmsg-replace": "true",
                                    },
                                  }),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "input" }, [
                                  _c("input", {
                                    staticClass: "req",
                                    attrs: {
                                      id: "agencyId",
                                      type: "text",
                                      name: "agencyId",
                                      maxlength: "255",
                                      "data-val": "true",
                                      "data-rule-minlength": "1",
                                      "data-rule-maxlength": "255",
                                      "data-msg-minlength":
                                        _vm.getValidationForField(
                                          "minChars",
                                          "1"
                                        ),
                                      "data-msg-maxlength":
                                        _vm.getValidationForField(
                                          "maxChars",
                                          "255"
                                        ),
                                      "data-val-required":
                                        _vm.getValidationForField(
                                          "required",
                                          "agencyId"
                                        ),
                                      "data-field-type": "SingleLineText",
                                      "data-default-value": _vm.advisorIata,
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    {
                                      staticClass: "req floating",
                                      attrs: { for: "agencyId" },
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.tc("formFields.agencyId")
                                          ) +
                                          "\n              "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("span", {
                                    staticClass: "field-validation-valid",
                                    attrs: {
                                      "data-valmsg-for": "agencyId",
                                      "data-valmsg-replace": "true",
                                    },
                                  }),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "input" }, [
                                  _c("input", {
                                    staticClass: "req",
                                    attrs: {
                                      id: "agencyEmail",
                                      type: "text",
                                      name: "agencyEmail",
                                      maxlength: "255",
                                      "data-val": "true",
                                      "data-val-external": "email",
                                      "data-rule-minlength": "6",
                                      "data-rule-maxlength": "255",
                                      "data-msg-minlength":
                                        _vm.getValidationForField(
                                          "minChars",
                                          "6"
                                        ),
                                      "data-msg-maxlength":
                                        _vm.getValidationForField(
                                          "maxChars",
                                          "255"
                                        ),
                                      "data-external-msg":
                                        _vm.getValidationForField(
                                          "externalEmail"
                                        ),
                                      "data-val-required":
                                        _vm.getValidationForField(
                                          "required",
                                          "email"
                                        ),
                                      "data-val-regex":
                                        _vm.getValidationForField("email"),
                                      "data-val-regex-pattern":
                                        "^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,17}$",
                                      "data-field-type": "Email",
                                      "data-default-value":
                                        _vm.agent && _vm.agent.agentEmail,
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    {
                                      staticClass: "req floating",
                                      attrs: { for: "agencyEmail" },
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(_vm.tc("formFields.email")) +
                                          "\n              "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("span", {
                                    staticClass: "field-validation-valid",
                                    attrs: {
                                      "data-valmsg-for": "agencyEmail",
                                      "data-valmsg-replace": "true",
                                    },
                                  }),
                                ]),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("hr", { staticClass: "spacer" }),
                          _vm._v(" "),
                          _c("fieldset", [
                            _c("legend", [
                              _vm._v(
                                _vm._s(_vm.tc("booking.fanClubClientInfo"))
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "flex-grid-1-col gutter-md" },
                              [
                                _c("div", { staticClass: "fomo-id" }, [
                                  _c("div", { staticClass: "input" }, [
                                    _c("input", {
                                      ref: "emailInput",
                                      staticClass: "req",
                                      attrs: {
                                        id: "email",
                                        type: "text",
                                        "data-default-value":
                                          _vm.user && _vm.user.email,
                                        name: "email",
                                        maxlength: "255",
                                        "data-val": "true",
                                        "data-val-external": "email",
                                        "data-rule-minlength": "6",
                                        "data-rule-maxlength": "255",
                                        "data-msg-minlength":
                                          _vm.getValidationForField(
                                            "minChars",
                                            "6"
                                          ),
                                        "data-msg-maxlength":
                                          _vm.getValidationForField(
                                            "maxChars",
                                            "255"
                                          ),
                                        "data-val-required":
                                          _vm.getValidationForField(
                                            "required",
                                            "email"
                                          ),
                                        "data-val-regex":
                                          _vm.getValidationForField("email"),
                                        "data-val-regex-pattern":
                                          "^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,17}$",
                                        "data-field-type": "Email",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "label",
                                      {
                                        staticClass: "req floating",
                                        attrs: { for: "email" },
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(_vm.tc("formFields.email")) +
                                            "\n                "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("span", {
                                      staticClass: "field-validation-valid",
                                      attrs: {
                                        "data-valmsg-for": "email",
                                        "data-valmsg-replace": "true",
                                      },
                                    }),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "input checkbox" }, [
                                    _c("label", [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.isFanMo,
                                            expression: "isFanMo",
                                          },
                                        ],
                                        attrs: {
                                          id: "fomoid",
                                          type: "checkbox",
                                          name: "fan-mo",
                                          "data-val": "true",
                                          "data-field-type": "CheckBoxSet",
                                        },
                                        domProps: {
                                          checked: Array.isArray(_vm.isFanMo)
                                            ? _vm._i(_vm.isFanMo, null) > -1
                                            : _vm.isFanMo,
                                        },
                                        on: {
                                          change: function ($event) {
                                            var $$a = _vm.isFanMo,
                                              $$el = $event.target,
                                              $$c = $$el.checked ? true : false
                                            if (Array.isArray($$a)) {
                                              var $$v = null,
                                                $$i = _vm._i($$a, $$v)
                                              if ($$el.checked) {
                                                $$i < 0 &&
                                                  (_vm.isFanMo = $$a.concat([
                                                    $$v,
                                                  ]))
                                              } else {
                                                $$i > -1 &&
                                                  (_vm.isFanMo = $$a
                                                    .slice(0, $$i)
                                                    .concat($$a.slice($$i + 1)))
                                              }
                                            } else {
                                              _vm.isFanMo = $$c
                                            }
                                          },
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.tc("formFields.clientIsFomo")
                                          )
                                        ),
                                      ]),
                                    ]),
                                    _vm._v(" "),
                                    _c("span", {
                                      staticClass: "field-validation-valid",
                                      attrs: {
                                        "data-valmsg-for": "fomoid",
                                        "data-valmsg-replace": "true",
                                      },
                                    }),
                                  ]),
                                  _vm._v(" "),
                                  _vm.isFanMo
                                    ? _c(
                                        "div",
                                        { staticClass: "fomo-id__look-up" },
                                        [
                                          _c("div", { staticClass: "input" }, [
                                            _c("input", {
                                              ref: "fomoIdInput",
                                              staticClass: "req",
                                              attrs: {
                                                id: "fansmoid",
                                                type: "text",
                                                "data-default-value":
                                                  _vm.user && _vm.user.fanId,
                                                name: "fansmoid",
                                                maxlength: "25",
                                                "data-val": "true",
                                                "data-rule-maxlength": "25",
                                                "data-val-required":
                                                  _vm.getValidationForField(
                                                    "required",
                                                    "fomoId"
                                                  ),
                                                "data-msg-maxlength":
                                                  _vm.getValidationForField(
                                                    "maxChars",
                                                    "25"
                                                  ),
                                                "data-field-type":
                                                  "SingleLineText",
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "label",
                                              {
                                                staticClass: "req floating",
                                                attrs: { for: "fansmoid" },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.tc(
                                                        "formFields.fomoId"
                                                      )
                                                    ) +
                                                    "\n                  "
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("span", {
                                              staticClass:
                                                "field-validation-valid",
                                              attrs: {
                                                "data-valmsg-for": "fansmoid",
                                                "data-valmsg-replace": "true",
                                              },
                                            }),
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "button button--secondary black size-md outlined",
                                              attrs: {
                                                disabled: _vm.loadingFomoData,
                                                type: "button",
                                              },
                                              on: { click: _vm.lookUpFomoData },
                                            },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.tc("formFields.lookUp")
                                                  ) +
                                                  "\n                "
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.displayFomoError
                                    ? _c(
                                        "span",
                                        { staticClass: "fomo-id__error" },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(_vm.fomoError) +
                                              "\n              "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "flex-grid-2-col gutter-md" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "input dropdown user-titles" },
                                  [
                                    _c(
                                      "select",
                                      {
                                        staticClass: "req",
                                        attrs: {
                                          id: "usertitle",
                                          name: "title",
                                          "data-default-value":
                                            _vm.user && _vm.user.title,
                                          "data-val": "true",
                                          "data-val-required":
                                            _vm.getValidationForField(
                                              "required",
                                              "title"
                                            ),
                                          "data-field-type": "DropdownList",
                                        },
                                      },
                                      [
                                        _c("option", { attrs: { value: "" } }),
                                        _vm._v(" "),
                                        _vm._l(
                                          _vm.userTitles,
                                          function (title) {
                                            return _c(
                                              "option",
                                              {
                                                key: title.value,
                                                domProps: {
                                                  value: title.value,
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                  " +
                                                    _vm._s(title.label) +
                                                    "\n                "
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                      ],
                                      2
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "label",
                                      {
                                        staticClass: "floating req",
                                        attrs: { for: "usertitle" },
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(_vm.tc("formFields.title")) +
                                            "\n              "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("span", {
                                      staticClass: "field-validation-valid",
                                      attrs: {
                                        "data-valmsg-for": "title",
                                        "data-valmsg-replace": "true",
                                      },
                                    }),
                                  ]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "flex-grid-2-col gutter-md" },
                              [
                                _c("div", { staticClass: "input" }, [
                                  _c("input", {
                                    staticClass: "req",
                                    attrs: {
                                      id: "firstname",
                                      type: "text",
                                      "data-default-value":
                                        _vm.user && _vm.user.firstName,
                                      name: "firstname",
                                      maxlength: "255",
                                      "data-val": "true",
                                      "data-rule-minlength": "1",
                                      "data-rule-maxlength": "50",
                                      "data-msg-minlength":
                                        _vm.getValidationForField(
                                          "minChars",
                                          "1"
                                        ),
                                      "data-msg-maxlength":
                                        _vm.getValidationForField(
                                          "maxChars",
                                          "50"
                                        ),
                                      "data-val-required":
                                        _vm.getValidationForField(
                                          "required",
                                          "firstName"
                                        ),
                                      "data-val-no-special-chars": _vm.tc(
                                        "validations.noSpecialChars"
                                      ),
                                      "data-field-type": "SingleLineText",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    {
                                      staticClass: "req floating",
                                      attrs: { for: "firstname" },
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.tc("formFields.firstName")
                                          ) +
                                          "\n              "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("span", {
                                    staticClass: "field-validation-valid",
                                    attrs: {
                                      "data-valmsg-for": "firstname",
                                      "data-valmsg-replace": "true",
                                    },
                                  }),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "input" }, [
                                  _c("input", {
                                    staticClass: "req",
                                    attrs: {
                                      id: "lastname",
                                      type: "text",
                                      "data-default-value":
                                        _vm.user && _vm.user.lastName,
                                      name: "lastname",
                                      maxlength: "255",
                                      "data-val": "true",
                                      "data-rule-minlength": "1",
                                      "data-rule-maxlength": "65",
                                      "data-msg-minlength":
                                        _vm.getValidationForField(
                                          "minChars",
                                          "1"
                                        ),
                                      "data-msg-maxlength":
                                        _vm.getValidationForField(
                                          "maxChars",
                                          "65"
                                        ),
                                      "data-val-required":
                                        _vm.getValidationForField(
                                          "required",
                                          "lastName"
                                        ),
                                      "data-val-no-special-chars": _vm.tc(
                                        "validations.noSpecialChars"
                                      ),
                                      "data-field-type": "SingleLineText",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    {
                                      staticClass: "req floating",
                                      attrs: { for: "lastname" },
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.tc("formFields.lastName")
                                          ) +
                                          "\n              "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("span", {
                                    staticClass: "field-validation-valid",
                                    attrs: {
                                      "data-valmsg-for": "lastname",
                                      "data-valmsg-replace": "true",
                                    },
                                  }),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "input dropdown country-code",
                                  },
                                  [
                                    _c("phone-country-select", {
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var handleSelectChange =
                                                ref.handleSelectChange
                                              return [
                                                _c(
                                                  "select",
                                                  {
                                                    attrs: {
                                                      id: "phoneCountryCode",
                                                      "data-default-value":
                                                        _vm.getCountryCodeDefaultSelectValue(),
                                                      name: "phoneCountryCode",
                                                      "data-val": "true",
                                                      "data-val-external":
                                                        "phone",
                                                      "data-external-msg":
                                                        _vm.getValidationForField(
                                                          "externalPhone"
                                                        ),
                                                      "data-val-required":
                                                        _vm.getValidationForField(
                                                          "required",
                                                          "phoneCountryCode"
                                                        ),
                                                      "data-field-type":
                                                        "DropdownList",
                                                    },
                                                    on: {
                                                      change:
                                                        handleSelectChange,
                                                    },
                                                  },
                                                  [
                                                    _c("option", {
                                                      attrs: { value: "" },
                                                    }),
                                                    _vm._v(" "),
                                                    !_vm.isBookingEditMode
                                                      ? _vm._l(
                                                          _vm.countries,
                                                          function (country) {
                                                            return _c(
                                                              "option",
                                                              {
                                                                key:
                                                                  country.Name +
                                                                  "Phone",
                                                                attrs: {
                                                                  "data-code":
                                                                    "+" +
                                                                    country.CallingCode,
                                                                  "data-country":
                                                                    country.Name,
                                                                },
                                                                domProps: {
                                                                  value:
                                                                    country.CallingCode,
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                        " +
                                                                    _vm._s(
                                                                      country.Name
                                                                    ) +
                                                                    " (+" +
                                                                    _vm._s(
                                                                      country.CallingCode
                                                                    ) +
                                                                    ")\n                      "
                                                                ),
                                                              ]
                                                            )
                                                          }
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _vm.isBookingEditMode
                                                      ? _vm._l(
                                                          _vm.countries,
                                                          function (country) {
                                                            return _c(
                                                              "option",
                                                              {
                                                                key:
                                                                  country.Name +
                                                                  "Phone",
                                                                attrs: {
                                                                  "data-code":
                                                                    "+" +
                                                                    country.CallingCode,
                                                                  "data-original-text":
                                                                    country.Name +
                                                                    " (+" +
                                                                    country.CallingCode +
                                                                    ")",
                                                                },
                                                                domProps: {
                                                                  value:
                                                                    country.CallingCode +
                                                                    "-" +
                                                                    country.IsoCode,
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                        " +
                                                                    _vm._s(
                                                                      country.Name
                                                                    ) +
                                                                    " (+" +
                                                                    _vm._s(
                                                                      country.CallingCode
                                                                    ) +
                                                                    ")\n                      "
                                                                ),
                                                              ]
                                                            )
                                                          }
                                                        )
                                                      : _vm._e(),
                                                  ],
                                                  2
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "label",
                                      {
                                        staticClass: "req floating",
                                        attrs: { for: "phoneCountryCode" },
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.tc(
                                                "formFields.phoneCountryCode"
                                              )
                                            ) +
                                            "\n              "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("span", {
                                      staticClass: "field-validation-valid",
                                      attrs: {
                                        "data-valmsg-for": "phoneCountryCode",
                                        "data-valmsg-replace": "true",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "input phone" }, [
                                  _c("input", {
                                    attrs: {
                                      id: "phoneNumber",
                                      type: "tel",
                                      "data-default-value": _vm.userPhoneNumber,
                                      name: "phoneNumber",
                                      "data-val": "true",
                                      "data-val-external": "phone",
                                      "data-external-msg":
                                        _vm.getValidationForField(
                                          "externalPhone"
                                        ),
                                      "data-val-required":
                                        _vm.getValidationForField(
                                          "required",
                                          "phoneNumber"
                                        ),
                                      "data-val-regex-pattern":
                                        "^[\\d\\+\\-\\(\\)\\s]*$",
                                      "data-val-regex":
                                        _vm.tc("validations.phone"),
                                      "data-rule-minlength": "5",
                                      "data-rule-maxlength": "17",
                                      "data-msg-minlength":
                                        _vm.getValidationForField(
                                          "minChars",
                                          "5"
                                        ),
                                      "data-msg-maxlength":
                                        _vm.getValidationForField(
                                          "maxChars",
                                          "17"
                                        ),
                                      "data-val-phone-number":
                                        _vm.tc("validations.phone"),
                                      "data-field-type": "PhoneNumber",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    {
                                      staticClass: "req floating",
                                      attrs: { for: "phoneNumber" },
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.tc("formFields.phoneNumber")
                                          ) +
                                          "\n              "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("span", {
                                    staticClass: "field-validation-valid",
                                    attrs: {
                                      "data-valmsg-for": "phoneNumber",
                                      "data-valmsg-replace": "true",
                                    },
                                  }),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "flex-grid-1-col gutter-md" },
                              [
                                _c("div", { staticClass: "input dropdown" }, [
                                  _c(
                                    "select",
                                    {
                                      attrs: {
                                        id: "country",
                                        name: "country",
                                        "data-default-value": _vm.userCountry,
                                        "data-val": "true",
                                        "data-val-required":
                                          _vm.getValidationForField(
                                            "required",
                                            "country"
                                          ),
                                        "data-field-type": "DropdownList",
                                      },
                                      on: {
                                        change: function ($event) {
                                          _vm.selectedCountry =
                                            $event.target.value
                                        },
                                      },
                                    },
                                    [
                                      _c("option", { attrs: { value: "" } }, [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.tc("formFields.selectCountry")
                                            ) +
                                            "\n                "
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _vm._l(_vm.countries, function (country) {
                                        return _c(
                                          "option",
                                          {
                                            key: country.Name + "Country",
                                            domProps: {
                                              value: country.IsoCode,
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(country.Name) +
                                                "\n                "
                                            ),
                                          ]
                                        )
                                      }),
                                    ],
                                    2
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    {
                                      staticClass: "req floating",
                                      attrs: { for: "country" },
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(_vm.tc("formFields.country")) +
                                          "\n              "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("span", {
                                    staticClass: "field-validation-valid",
                                    attrs: {
                                      "data-valmsg-for": "country",
                                      "data-valmsg-replace": "true",
                                    },
                                  }),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "input" }, [
                                  _c("input", {
                                    staticClass: "req",
                                    attrs: {
                                      id: "streetAddress",
                                      type: "text",
                                      "data-default-value":
                                        _vm.userAddressLineOne,
                                      name: "streetAddress",
                                      maxlength: "255",
                                      "data-val": "true",
                                      "data-rule-minlength": "1",
                                      "data-rule-maxlength": "255",
                                      "data-msg-minlength":
                                        _vm.getValidationForField(
                                          "minChars",
                                          "1"
                                        ),
                                      "data-msg-maxlength":
                                        _vm.getValidationForField(
                                          "maxChars",
                                          "255"
                                        ),
                                      "data-val-required":
                                        _vm.getValidationForField(
                                          "required",
                                          "stretAdress"
                                        ),
                                      "data-val-address": _vm.tc(
                                        "validations.address"
                                      ),
                                      "data-field-type": "SingleLineText",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    {
                                      staticClass: "req floating",
                                      attrs: { for: "streetAddress" },
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.tc("formFields.stretAdress")
                                          ) +
                                          "\n              "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("span", {
                                    staticClass: "field-validation-valid",
                                    attrs: {
                                      "data-valmsg-for": "streetAddress",
                                      "data-valmsg-replace": "true",
                                    },
                                  }),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "input" }, [
                                  _c("input", {
                                    staticClass: "req",
                                    attrs: {
                                      id: "city",
                                      type: "text",
                                      "data-default-value": _vm.userCity,
                                      name: "city",
                                      maxlength: "255",
                                      "data-val": "true",
                                      "data-val-required":
                                        _vm.getValidationForField(
                                          "required",
                                          "city"
                                        ),
                                      "data-field-type": "SingleLineText",
                                      "data-rule-minlength": "1",
                                      "data-rule-maxlength": "50",
                                      "data-msg-minlength":
                                        _vm.getValidationForField(
                                          "minChars",
                                          "1"
                                        ),
                                      "data-msg-maxlength":
                                        _vm.getValidationForField(
                                          "maxChars",
                                          "50"
                                        ),
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    {
                                      staticClass: "req floating",
                                      attrs: { for: "city" },
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(_vm.tc("formFields.city")) +
                                          "\n              "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("span", {
                                    staticClass: "field-validation-valid",
                                    attrs: {
                                      "data-valmsg-for": "city",
                                      "data-valmsg-replace": "true",
                                    },
                                  }),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "flex-grid-2-col gutter-md" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "input",
                                    class: [{ dropdown: _vm.haveStates }],
                                  },
                                  [
                                    !_vm.haveStates
                                      ? _c("input", {
                                          attrs: {
                                            id: "state",
                                            type: "text",
                                            "data-default-value": _vm.userState,
                                            name: "state",
                                            maxlength: "255",
                                            "data-field-type": "SingleLineText",
                                          },
                                        })
                                      : _c(
                                          "select",
                                          {
                                            attrs: {
                                              id: "state",
                                              type: "text",
                                              "data-default-value":
                                                _vm.userState,
                                              "data-val": "true",
                                              "data-val-required":
                                                _vm.getValidationForField(
                                                  "required",
                                                  "state"
                                                ),
                                              name: "state",
                                              maxlength: "255",
                                              "data-field-type": "DropdownList",
                                            },
                                          },
                                          [
                                            _c("option", {
                                              attrs: { value: "" },
                                              domProps: {
                                                textContent:
                                                  _vm._s("Select state"),
                                              },
                                            }),
                                            _vm._v(" "),
                                            _vm._l(
                                              _vm.availableStates,
                                              function (state) {
                                                return _c("option", {
                                                  key:
                                                    state.value || state.label,
                                                  domProps: {
                                                    value:
                                                      state.value ||
                                                      state.label,
                                                    textContent: _vm._s(
                                                      state.label
                                                    ),
                                                  },
                                                })
                                              }
                                            ),
                                          ],
                                          2
                                        ),
                                    _vm._v(" "),
                                    _c(
                                      "label",
                                      {
                                        staticClass: "floating",
                                        class: [{ req: _vm.haveStates }],
                                        attrs: { for: "state" },
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(_vm.tc("formFields.state")) +
                                            "\n              "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm.haveStates
                                      ? _c("span", {
                                          staticClass: "field-validation-valid",
                                          attrs: {
                                            "data-valmsg-for": "state",
                                            "data-valmsg-replace": "true",
                                          },
                                        })
                                      : _vm._e(),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "input" }, [
                                  _c("input", {
                                    staticClass: "req",
                                    attrs: {
                                      id: "zipCode",
                                      type: "text",
                                      "data-default-value": _vm.userPostalCode,
                                      name: "zipCode",
                                      maxlength: "255",
                                      "data-val": "true",
                                      "data-rule-minlength": "1",
                                      "data-rule-maxlength": "26",
                                      "data-msg-minlength":
                                        _vm.getValidationForField(
                                          "minChars",
                                          "1"
                                        ),
                                      "data-msg-maxlength":
                                        _vm.getValidationForField(
                                          "maxChars",
                                          "26"
                                        ),
                                      "data-val-required":
                                        _vm.getValidationForField(
                                          "required",
                                          "zipCode"
                                        ),
                                      "data-val-zipcode": _vm.tc(
                                        "validations.zipcode"
                                      ),
                                      "data-field-type": "SingleLineText",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    {
                                      staticClass: "req floating",
                                      attrs: { for: "zipCode" },
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(_vm.tc("formFields.zipCode")) +
                                          "\n              "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("span", {
                                    staticClass: "field-validation-valid",
                                    attrs: {
                                      "data-valmsg-for": "zipCode",
                                      "data-valmsg-replace": "true",
                                    },
                                  }),
                                ]),
                                _vm._v(" "),
                                !_vm.isBookingEditMode
                                  ? _c("div", { staticClass: "input" }, [
                                      _c("input", {
                                        attrs: {
                                          id: "dateOfBirth",
                                          type: "date",
                                          "data-default-value":
                                            _vm.dateFormatted,
                                          name: "dateOfBirth",
                                          maxlength: "255",
                                          "data-val": "true",
                                          "data-field-type": "SingleLineText",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "label",
                                        {
                                          staticClass: "floating",
                                          attrs: { for: "dateOfBirth" },
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.tc("formFields.dateOfBirth")
                                              ) +
                                              "\n              "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("span", {
                                        staticClass: "field-validation-valid",
                                        attrs: {
                                          "data-valmsg-for": "dateOfBirth",
                                          "data-valmsg-replace": "true",
                                        },
                                      }),
                                    ])
                                  : _vm._e(),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "flex-grid-1-col gutter-md" },
                              [
                                _vm.isBookingEditMode
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "additional-guests-wrapper",
                                      },
                                      [
                                        _vm.ModifyReservationAdditionalGuestTitle
                                          ? _c(
                                              "div",
                                              { staticClass: "guest-title" },
                                              [
                                                _vm._v(
                                                  "\n                " +
                                                    _vm._s(
                                                      _vm.ModifyReservationAdditionalGuestTitle
                                                    ) +
                                                    "\n              "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.ModifyReservationAdditionalGuestSubTitle
                                          ? _c(
                                              "div",
                                              { staticClass: "guest-subtitle" },
                                              [
                                                _vm._v(
                                                  "\n                " +
                                                    _vm._s(
                                                      _vm.ModifyReservationAdditionalGuestSubTitle
                                                    ) +
                                                    "\n              "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "additional-guests" },
                                          _vm._l(
                                            _vm.groupedReservations,
                                            function (
                                              reservation,
                                              confirmationNumber,
                                              index
                                            ) {
                                              return _c(
                                                "div",
                                                {
                                                  key: confirmationNumber,
                                                  staticClass:
                                                    "additional-guest",
                                                },
                                                [
                                                  _vm.isMultiRoomReservation
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "additional-guest-room-name-number",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                    " +
                                                              _vm._s(
                                                                _vm.tc(
                                                                  "noums.roomSingular"
                                                                )
                                                              ) +
                                                              " " +
                                                              _vm._s(
                                                                _vm.getRoomNumberOrder(
                                                                  confirmationNumber
                                                                )
                                                              ) +
                                                              "\n                  "
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.isMultiRoomReservation
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "additional-guest-room-name-label",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                    " +
                                                              _vm._s(
                                                                _vm.getRoomName(
                                                                  confirmationNumber
                                                                )
                                                              ) +
                                                              "\n                  "
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm._l(
                                                    _vm.additionalGuests,
                                                    function (guest, i) {
                                                      return _c(
                                                        "div",
                                                        {
                                                          key:
                                                            "guest-" + guest.id,
                                                          staticClass:
                                                            "additional-guest-input",
                                                          class: {
                                                            "has-guests":
                                                              _vm
                                                                .additionalGuests
                                                                .length,
                                                          },
                                                        },
                                                        [
                                                          guest.confirmationNumber ===
                                                          confirmationNumber
                                                            ? _c(
                                                                "additional-guests-input",
                                                                {
                                                                  ref: "additionalGuestInput",
                                                                  refInFor: true,
                                                                  attrs: {
                                                                    index:
                                                                      i + 1,
                                                                    guest:
                                                                      guest,
                                                                  },
                                                                  on: {
                                                                    remove:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.removeGuest(
                                                                          guest.id
                                                                        )
                                                                      },
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm
                                                                        .additionalGuests[
                                                                        guest.id
                                                                      ],
                                                                    callback:
                                                                      function (
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          _vm.additionalGuests,
                                                                          guest.id,
                                                                          $$v
                                                                        )
                                                                      },
                                                                    expression:
                                                                      "additionalGuests[guest.id]",
                                                                  },
                                                                }
                                                              )
                                                            : _vm._e(),
                                                        ],
                                                        1
                                                      )
                                                    }
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "button",
                                                    {
                                                      staticClass: "add-guest",
                                                      class: {
                                                        hide:
                                                          _vm.guestCounts[
                                                            confirmationNumber
                                                          ] >= 2,
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          $event.preventDefault()
                                                          return _vm.addGuest(
                                                            confirmationNumber
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c("span", {
                                                        staticClass:
                                                          "icon-plus",
                                                      }),
                                                      _vm._v(" "),
                                                      _vm.ModifyReservationAdditionalGuestCTALabel
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "label",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.ModifyReservationAdditionalGuestCTALabel
                                                                )
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ]
                                                  ),
                                                ],
                                                2
                                              )
                                            }
                                          ),
                                          0
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("hr", { staticClass: "spacer" }),
                          _vm._v(" "),
                          !_vm.isDirectBill
                            ? _c(
                                "fieldset",
                                [
                                  _c("legend", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.tc("booking.fcpaymentInformation")
                                      )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _vm.isBookingEditMode
                                    ? _c("CardManagement", {
                                        attrs: {
                                          "vgs-endpoint": _vm.vgsBaseUrl,
                                          "is-using-vgs": _vm.isUsingVgs,
                                        },
                                      })
                                    : _vm.isUsingVgs
                                    ? _c("vgs-form", {
                                        ref: "vgsForm",
                                        attrs: {
                                          variant: "default",
                                          "card-holder": _vm.tc(
                                            "formFields.cardHolder"
                                          ),
                                          "card-number-field": _vm.tc(
                                            "formFields.cardNumber"
                                          ),
                                          "exp-date-field": _vm.tc(
                                            "formFields.cardExpirationDate"
                                          ),
                                          "cvc-field":
                                            _vm.tc("formFields.cardCvc"),
                                          "vgs-endpoint": _vm.vgsBaseUrl,
                                          "field-class": "input",
                                        },
                                      })
                                    : _c("credit-card-form"),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.isDirectBill
                            ? _c("hr", { staticClass: "spacer" })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("fieldset", [
                            _c("legend", [
                              _vm._v(
                                _vm._s(
                                  _vm.tc("booking.fcadditionalInformation")
                                )
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "p",
                              { staticClass: "reasons-for-stay-label req" },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.tc("booking.reasonsForStayLabel")
                                    ) +
                                    "\n          "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "input radio" },
                              [
                                _vm._l(_vm.reasonsToStay, function (reason) {
                                  return _c("label", { key: reason.value }, [
                                    _c("input", {
                                      attrs: {
                                        id: reason.value,
                                        type: "radio",
                                        name: "reasonsToStay",
                                        "data-default-value": reason.value,
                                        "data-val": "true",
                                        "data-val-required":
                                          _vm.getValidationForField(
                                            "stayReasons"
                                          ),
                                      },
                                      domProps: { value: reason.value },
                                    }),
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(reason.label) +
                                        "\n            "
                                    ),
                                  ])
                                }),
                                _vm._v(" "),
                                _c("span", {
                                  staticClass: "field-validation-valid",
                                  attrs: {
                                    "data-valmsg-for": "reasonsToStay",
                                    "data-valmsg-replace": "true",
                                  },
                                }),
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(
                                _vm._s(
                                  _vm.tc("booking.anyThingAnythingelseYourStay")
                                )
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "input" }, [
                              _c("textarea", {
                                attrs: {
                                  id: "details",
                                  name: "details",
                                  rows: "10",
                                  placeholder: _vm.tc("booking.enterDetails"),
                                },
                              }),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("hr", { staticClass: "spacer" }),
                          _vm._v(" "),
                          !_vm.isFanClubBooking &&
                          _vm.showRoomUpgradeButton &&
                          !_vm.isBookingEditMode
                            ? _c(
                                "fieldset",
                                { staticClass: "room-upgrade-banner-fieldset" },
                                [
                                  _c("legend", { staticClass: "sr-only" }, [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(_vm.tc("booking.upgradeRoom")) +
                                        "\n          "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("room-upgrade-banner"),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.roomUpgradeSelected
                            ? _c("input", {
                                attrs: {
                                  type: "hidden",
                                  name: "UpgradedDetails",
                                },
                                domProps: { value: _vm.upgradedDetails },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.roomUpgradeSelected
                            ? _c("input", {
                                attrs: {
                                  type: "hidden",
                                  name: "UpgradePriceDifferencePerNight",
                                },
                                domProps: {
                                  value: _vm.upgradePriceDifferencePerNight,
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("input", {
                            attrs: { type: "hidden", name: "directBill" },
                            domProps: { value: _vm.isDirectBill },
                          }),
                          _vm._v(" "),
                          _c("input", {
                            attrs: {
                              type: "hidden",
                              value: "123",
                              name: "directBillAddress",
                            },
                          }),
                          _vm._v(" "),
                          !_vm.isFanClubBooking &&
                          _vm.showRoomUpgradeButton &&
                          !_vm.isBookingEditMode
                            ? _c("hr", { staticClass: "spacer" })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("fieldset", [
                            _c("legend", [
                              _vm._v(
                                _vm._s(
                                  _vm.tc(
                                    "booking.fctermsAndContitionsInformation"
                                  )
                                )
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "flex-grid-1-col gutter-md terms-wrapper",
                              },
                              [
                                _vm.check.isMdAndDown
                                  ? _c(
                                      "div",
                                      { staticClass: "booking-terms" },
                                      [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(
                                              _vm.tc(
                                                "bookingTerms.termsAndPoliciesText"
                                              )
                                            ) +
                                            "\n              "
                                        ),
                                        _c(
                                          "a",
                                          {
                                            attrs: {
                                              href: _vm.tc(
                                                "bookingTerms.termsAndPoliciesLink"
                                              ),
                                              target: "_blank",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(
                                                  _vm.tc(
                                                    "bookingTerms.termsAndPoliciesLabel"
                                                  )
                                                ) +
                                                "\n              "
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm._l(_vm.hotelTerms, function (term, i) {
                                  return _c(
                                    "div",
                                    {
                                      key: "terms" + i,
                                      staticClass: "input checkbox",
                                    },
                                    [
                                      _c("label", [
                                        _c("input", {
                                          attrs: {
                                            id: "terms_" + i,
                                            type: "checkbox",
                                            name: "terms_" + i,
                                            "data-val": "true",
                                            "data-val-ischecked": _vm.tc(
                                              "validations.ischecked"
                                            ),
                                            "data-field-type": "CheckBoxSet",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("span", {
                                          domProps: { innerHTML: _vm._s(term) },
                                        }),
                                      ]),
                                      _vm._v(" "),
                                      _c("span", {
                                        staticClass: "field-validation-valid",
                                        attrs: {
                                          "data-valmsg-for": "terms_" + i,
                                          "data-valmsg-replace": "true",
                                        },
                                      }),
                                    ]
                                  )
                                }),
                                _vm._v(" "),
                                _vm.check.isLgAndUp
                                  ? _c(
                                      "div",
                                      { staticClass: "booking-terms" },
                                      [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(
                                              _vm.tc(
                                                "bookingTerms.termsAndPoliciesText"
                                              )
                                            ) +
                                            "\n              "
                                        ),
                                        _c(
                                          "a",
                                          {
                                            attrs: {
                                              href: _vm.tc(
                                                "bookingTerms.termsAndPoliciesLink"
                                              ),
                                              target: "_blank",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(
                                                  _vm.tc(
                                                    "bookingTerms.termsAndPoliciesLabel"
                                                  )
                                                ) +
                                                "\n              "
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              2
                            ),
                          ]),
                          _vm._v(" "),
                          _c("hr", { staticClass: "spacer no-margin" }),
                          _vm._v(" "),
                          _c("div", { staticClass: "form-footer" }, [
                            _c(
                              "div",
                              { staticClass: "overview-item no-margin" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "item-label bold-item" },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(_vm.tc("booking.total")) +
                                        "\n            "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.cart
                                  ? _c("div", { staticClass: "item-value" }, [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(_vm.cartTotal) +
                                          "\n              "
                                      ),
                                      _vm.check.isLgAndDown
                                        ? _c(
                                            "a",
                                            {
                                              staticClass: "details",
                                              attrs: { href: "#" },
                                              on: {
                                                click: function ($event) {
                                                  $event.preventDefault()
                                                  return _vm.$emit("show-cart")
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.tc("booking.details")
                                                )
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ])
                                  : _vm._e(),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "button",
                                class: [{ loading: _vm.isLoading }],
                                attrs: {
                                  type: "submit",
                                  name: "checkout-form-submit",
                                  value: "Submit Button",
                                },
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(_vm.tc("booking.checkOut")) +
                                    "\n            "
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass: "sr-only",
                                    attrs: { role: "status" },
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.isLoading
                                            ? _vm.tc(
                                                "accessibility.loadingButtonStatus"
                                              )
                                            : ""
                                        ) +
                                        "\n            "
                                    ),
                                  ]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            serverErrorMsg
                              ? _c("div", { staticClass: "error-box" }, [
                                  _c("span", [_vm._v(_vm._s(serverErrorMsg))]),
                                ])
                              : _vm._e(),
                          ]),
                        ]
                      )
                    },
                  },
                ],
                null,
                false,
                2553855260
              ),
            }),
            _vm._v(" "),
            _c("div", { staticClass: "restriction-policy" }, [
              _c(
                "div",
                { staticClass: "restriction-policy-wrapper" },
                [
                  _c("div", { staticClass: "section-title" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.tc("booking.restrictionPolicy")) +
                        "\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.ratesRestrictionPolicy, function (item, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "restriction-policy-item" },
                      [
                        _c("div", {
                          staticClass: "restriction-policy-title",
                          domProps: { innerHTML: _vm._s(item.title) },
                        }),
                        _vm._v(" "),
                        _c("ul", {
                          staticClass: "restriction-policy-body",
                          domProps: {
                            innerHTML: _vm._s(item.restrictionPolicy),
                          },
                        }),
                      ]
                    )
                  }),
                ],
                2
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "disclaimer" }, [
              _c("p", [_vm._v(_vm._s(_vm.tc("booking.riskFreeBooking")))]),
              _vm._v(" "),
              _vm.tc("bookingTerms.freeCancellationsLink")
                ? _c("p", [
                    _c(
                      "a",
                      {
                        attrs: {
                          href: _vm.tc("bookingTerms.freeCancellationsLink"),
                          target: "_blank",
                        },
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.tc("bookingTerms.freeCancellationsLabel"))
                        ),
                      ]
                    ),
                    _vm._v(
                      "\n        " + _vm._s(_vm.tc("booking.upTo")) + "\n      "
                    ),
                  ])
                : _vm._e(),
            ]),
          ],
          1
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }